module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listContent"
  }, [(!_vm.isShare) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussID,
          topicItem: _vm.topicItem
        }
      }
    }
  }, [_c('div', {
    class: _vm.contC,
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.content))
    }
  })]), _vm._v(" "), (_vm.isImgShow && _vm.attUrls.pics) ? _c('div', {
    class: _vm.imgContainer
  }, _vm._l((_vm.attUrls.pics), function(img, imgindex) {
    return _c('img', {
      key: img,
      class: _vm.imgC,
      attrs: {
        "src": ("" + (img.url.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')))
      },
      on: {
        "click": function($event) {
          _vm.bigImage(imgindex)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'topicColumnDetail',
        params: {
          discussID: _vm.discussID,
          topicItem: _vm.topicItem
        }
      }
    }
  }, [(_vm.isTipShow) ? _c('div', {
    staticClass: "listContent_tip themeColor"
  }, [_vm._v("更多精彩内容，看详情")]) : _vm._e()])], 1) : _c('div', [_c('div', [_c('div', {
    class: _vm.contC,
    domProps: {
      "innerHTML": _vm._s(_vm.parseSpace(_vm.content))
    }
  })]), _vm._v(" "), (_vm.isImgShow && _vm.attUrls.pics) ? _c('div', {
    class: _vm.imgContainer
  }, _vm._l((_vm.attUrls.pics), function(img, imgindex) {
    return _c('img', {
      key: img,
      class: _vm.imgC,
      attrs: {
        "src": ("" + (img.url.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')))
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.openHrefApp
    }
  }, [(_vm.isTipShow) ? _c('div', {
    staticClass: "listContent_tip themeColor"
  }, [_vm._v("更多精彩内容 请下载客户端查看")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf97414c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topic/listcontent.vue
// module id = 332
// module chunks = 1